import { useState, useEffect } from "react";
import { saveAssetStatus } from "../../Api/AssetManagement";
import { Container, Form, Button, Row, Col } from "react-bootstrap";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Sample14 from "../../Components/Logo";
import { useAssetContext } from '../../Context/MasterContext/AssetContext';

const UpdateAssetStatus = () => {
    const navigate = useNavigate();
    const { assetConTypes,
        loadConTypes,
        fetchAssetData,
        loadAssetMaster,  assetStatus,
                loadAssetStatus } = useAssetContext();
    const [loading, setLoading] = useState(false);
    const userDetails = JSON.parse(localStorage.getItem("userDetails"));
    const userId = userDetails?.userId;
    console.log("UserId: ", userId);

    const intitalValues = {
        asset_ID: "",
        current_Status: "",
        asset_Condition: "",
        date_of_Disposal: "",
        scrap_Value: "",
        remarks: ""
    }

    const [formValues, setFormValues] = useState(intitalValues);

    console.log(assetStatus, 'assetStatus');


    const handleChange = (e) => {
        setFormValues({ ...formValues, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await saveAssetStatus(formValues, userId);
            toast.success(`🦄 Status Updated Successfully`);
            setFormValues(intitalValues);
            // navigate("/assets/view-assets");
        } catch (error) {
            toast.error(`🦄 Error : ${error.message}`);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        loadConTypes();
        loadAssetMaster();
        loadAssetStatus();
    }, []);

    return (
        <>
            <div className="main-content expand">
                <Container fluid className="fields-container">
                    <h2 className="fields-title">Update Asset Status</h2>

                    {loading && (
                        <div className="loading-overlay">
                            <Sample14 />
                        </div>
                    )}

                    <Form onSubmit={handleSubmit} className="fields-form">
                        <Row>
                            <Col md={4}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Asset ID <span className="text-red">**</span></Form.Label>
                                    <Form.Select
                                        name="asset_ID"
                                        value={formValues.asset_ID}
                                        onChange={handleChange}
                                        required
                                    >
                                        <option value="">Select Asset</option>
                                        {fetchAssetData.map((option) => (
                                            <option key={option.asset_ID} value={option.asset_ID}>
                                                {option.asset_ID}
                                            </option>
                                        ))}
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                            <Col md={4}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Asset Status <span className="text-red">**</span></Form.Label>
                                    <Form.Select
                                        name="current_Status"
                                        value={formValues.current_Status}
                                        onChange={handleChange}
                                        required
                                    >
                                        <option value="">Select Status</option>
                                        {assetStatus.map((option) => (
                                            <option key={option.statusListId} value={option.statusListId}>
                                                {option.statusListId} - {option.statusValue} 
                                            </option>
                                        ))}
                                    </Form.Select>
                                </Form.Group>
                            </Col>


                            <Col md={4}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Asset Condition <span className="text-red">**</span></Form.Label>
                                    <Form.Select
                                        name="asset_Condition"
                                        value={formValues.asset_Condition}
                                        onChange={handleChange}
                                        required
                                    >
                                        <option value="">Select Condition</option>
                                        {assetConTypes.map((option) => (
                                            <option key={option.conditionId} value={option.conditionId}>
                                                {option.conditionDesc}
                                            </option>
                                        ))}
                                    </Form.Select>
                                </Form.Group>
                            </Col>

                            <Col md={4}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Date of Disposal</Form.Label>
                                    <Form.Control
                                        type="date"
                                        name="date_of_Disposal"
                                        value={formValues.date_of_Disposal}
                                        onChange={handleChange}
                                    />
                                </Form.Group>
                            </Col>


                            <Col md={4}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Scrap Value</Form.Label>
                                    <Form.Control
                                        type="number"
                                        name="scrap_Value"
                                        value={formValues.scrap_Value}
                                        onChange={handleChange}
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={4}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Remarks</Form.Label>
                                    <Form.Control
                                        as="textarea"
                                        rows={3}
                                        name="remarks"
                                        value={formValues.remarks}
                                        onChange={handleChange}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>

                        <div className="fields-btn-container">
                            <Button
                                variant="primary"
                                type="submit"
                                className="fields-submit"
                                disabled={loading}
                            >
                                {loading ? "Saving..." : "Save Asset"}
                            </Button>
                        </div>
                    </Form>
                </Container>
            </div>
        </>
    );
};

export default UpdateAssetStatus